module.exports = __webpack_public_path__ + "static/automation-playbook-3d-1b4908262d1b4d8ddb10dac04b7f9bec.png";